import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import patchTransitionProposal from "../requests/patchTransitionProposal";
import { getTransitionProposalKeyMaker } from "./useGetTransitionProposal";
import { getTransitionProposalsKeyMaker } from "./useGetTransitionProposals";
import { getUnreadTransitionProposalsKeyMaker } from "./useGetUnreadTransitionProposalsCount";
const IDEMPOTENCY_DESCRIPTOR = "patch-transition-proposal";
const usePatchTransitionProposal = (config) => {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ body, transitionProposalId }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return patchTransitionProposal(body, transitionProposalId, idempotencyKey, config);
        },
        onMutate: ({ body, transitionProposalId }) => {
            const params = config?.clientId !== undefined
                ? {
                    clientId: config.clientId,
                }
                : null;
            const queryKey = getTransitionProposalsKeyMaker(params);
            queryClient.cancelQueries(queryKey);
            const previousData = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (oldResponse) => {
                if (!oldResponse?.data) {
                    return oldResponse;
                }
                const newResponse = {
                    ...oldResponse,
                    data: oldResponse.data.map((proposal) => {
                        const importType = body.importType ?? proposal.importType;
                        return proposal.transitionProposalId === transitionProposalId
                            ? {
                                ...proposal,
                                importType,
                            }
                            : proposal;
                    }),
                };
                return newResponse;
            });
            return { previousData };
        },
        onError: (_error, _variables, context) => {
            if (context?.previousData !== undefined) {
                queryClient.setQueryData(getTransitionProposalsKeyMaker(null), context.previousData);
            }
        },
        onSuccess: (_, { transitionProposalId }) => {
            queryClient.invalidateQueries({
                queryKey: getTransitionProposalsKeyMaker(null),
            });
            queryClient.invalidateQueries({
                queryKey: getTransitionProposalKeyMaker(transitionProposalId),
            });
            // Invalidate unread transition proposals count
            if (config?.clientId) {
                queryClient.invalidateQueries({
                    queryKey: getUnreadTransitionProposalsKeyMaker(config.clientId),
                });
            }
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePatchTransitionProposal;
//# sourceMappingURL=usePatchTransitionProposal.js.map